// src/components/BoardPackConfiguration/pages/GenericPagePreview.jsx
import { CATEGORY_COLORS, PAGE_TYPE_MAP } from "../data";

const GenericPagePreview = ({ page }) => {
  const typeInfo = PAGE_TYPE_MAP[page?.type];
  const catColor = CATEGORY_COLORS[typeInfo?.category] || "bg-gray-100 text-gray-700 border-gray-200";
  const icons = { Tables: "▦", Charts: "▲", Profiles: "◉", Layout: "▣" };

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 select-none">
      <div className={`h-16 w-16 rounded-2xl border-2 flex items-center justify-center text-2xl ${catColor}`}>
        {icons[typeInfo?.category] || "◻"}
      </div>
      <div className="text-center">
        <p className="text-sm font-semibold text-foreground">{page?.title || typeInfo?.label}</p>
        <p className="text-[11px] font-mono text-muted-foreground mt-0.5">{page?.type}</p>
      </div>
      <span className={`text-[10px] px-2 py-0.5 rounded border font-medium ${catColor}`}>
        {typeInfo?.category} · Preview not available
      </span>
    </div>
  );
};
export default GenericPagePreview;